import React from "react";
import { useNavigate } from "react-router-dom";

const PagoPendiente = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4 py-8">
      <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-10 text-center max-w-md w-full border border-gray-300">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-yellow-600 mb-4">
          Pago pendiente
        </h2>
        <p className="text-gray-600 mb-6">
          Tu pago está siendo procesado. Te notificaremos cuando se confirme.
        </p>
        <button
          onClick={() => navigate("/tienda")}
          className="bg-black text-white px-6 py-3 rounded-xl font-semibold hover:bg-gray-900 transition w-full sm:w-auto"
        >
          Volver a la tienda
        </button>
      </div>
    </div>
  );
};

export default PagoPendiente;
